import { render, staticRenderFns } from "./PurchaseOrderImport.vue?vue&type=template&id=18579899&"
import script from "./PurchaseOrderImport.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports